import React from 'react';
import { Box, Typography } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const COLORS = {
  opened: '#28be5f',
  unopened: '#6b6666'
};

export default function EmailOverviewChart({ metrics }) {
  const data = [
    { name: 'Opened', value: metrics.totalOpened },
    { name: 'Unopened', value: metrics.totalUnopened }
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <Box sx={{ backgroundColor: 'white', p: 1, border: '1px solid #ccc' }}>
          <Typography variant="body2">{payload[0].name}</Typography>
          <Typography variant="body2" fontWeight="bold">
            {payload[0].value} emails ({((payload[0].value / metrics.totalSent) * 100).toFixed(1)}%)
          </Typography>
        </Box>
      );
    }
    return null;
  };

  return (
    <Box padding={2}>
      <Typography variant="h6" gutterBottom>
        Email Open Rate
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ value, percent }) => `${value} (${(percent * 100).toFixed(0)}%)`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            <Cell fill={COLORS.opened} />
            <Cell fill={COLORS.unopened} />
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
      <Box textAlign="center" mt={2}>
        <Typography variant="h3" color="primary">
          {metrics.openRate}%
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Overall Open Rate
        </Typography>
      </Box>
    </Box>
  );
}